import React from "react";
import { Link } from "react-router-dom";
import { CampaignHero, Arrow, SectionHeading, OutcomeCTA } from "../components/CampaignHero";
import { ExperienceJourney } from "../components/ExperienceJourney";
import { IndustryCollection } from "../components/IndustryCollection";
import ThreeProducts from "../components/ThreeProducts";
import { PAPERS } from "../lib/lab";
import campaign from "../lib/campaign.json";
import { TAGLINE } from "../lib/brand";
import { PartnersTeaser } from "../components/PartnersTeaser";

export default function HomePage({ onDemo }) {
  return <main data-testid="home-page" className="campaign-page">
    <CampaignHero id="home" image="home" eyebrow="Helios Brain · Applied Intelligence Lab" title={campaign.headline} description={TAGLINE} onDemo={onDemo} footer="You define the outcome. Helios finds the path.">
      <Link to="/industries" className="hero-world-link" data-testid="home-world-link"><span>Intelligence for the real world</span><Arrow down /></Link>
    </CampaignHero>
    <section className="campaign-intro" data-testid="home-introduction"><div className="campaign-container intro-layout"><h2 className="campaign-section-label">Expand the possible.</h2><div><p className="intro-statement">The world doesn’t need<br />another answer.<br /><span>It needs a way forward.</span></p><p className="campaign-body">{campaign.description}</p></div></div></section>
    <IndustryCollection preview />
    <ExperienceJourney compact id="home" />
    <ThreeProducts />
    <PartnersTeaser id="home" />
    <section className="campaign-section home-research" data-testid="home-research"><div className="campaign-container">
      <SectionHeading id="home-research" eyebrow="From the lab" title="The thinking behind the path."><Link to="/research" data-testid="home-research-all" className="campaign-text-link">Explore our research<Arrow /></Link></SectionHeading>
      <div className="research-editorial-list">{PAPERS.slice(0, 3).map((paper, i) => <Link to={`/papers/${paper.slug}`} key={paper.slug} data-testid={`home-paper-${paper.slug}`}><span className="campaign-micro">0{i + 1} / Research</span><h3>{paper.title}</h3><Arrow /></Link>)}</div>
    </div></section>
    <OutcomeCTA onDemo={onDemo} id="home" />
  </main>;
}